__turbopack_context__.v({
  "dWrap": "row-module__BY5E3G__dWrap",
  "desktopScrollable": "row-module__BY5E3G__desktopScrollable",
  "directionCol": "row-module__BY5E3G__directionCol",
  "noGap": "row-module__BY5E3G__noGap",
  "row": "row-module__BY5E3G__row",
  "sDirectionCol": "row-module__BY5E3G__sDirectionCol",
  "scrollable": "row-module__BY5E3G__scrollable",
  "wrap": "row-module__BY5E3G__wrap",
});
